import { FC, HTMLAttributes, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  Chair,
  Container,
  Content,
  Inner,
  Navigation,
  Plant,
  Wrapper,
  ResultsWrapper,
  ResultsContainer,
} from './Layout.styles';
import { ProgressBar, Button } from '@sleepunique/components/atoms';
import { usePreviousStep } from '@sleepunique/hooks';
import { usePageContext, useSleeperDataContext } from '@sleepunique/context';

const chair = require('./chair_blue.png');
const plant = require('./plant_blue.png');

const Layout: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className }) => {
  const [progressBarValue, setProgressBarValue] = useState<number>(0);
  const { layoutVariant, page, showNavigation, setPage, backPage, isResultsPage } = usePageContext();
  const { currentSleeper, setCurrentSleeper } = useSleeperDataContext();

  const { getValues } = useFormContext();
  const previousStep = usePreviousStep();
  const currentForm = getValues();

  const allQuestions = new Map();

  const setAllQuestions = () => {
    const topLevelQuestions = Object.fromEntries(
      Object.entries(currentForm).filter(
        ([key]) => key !== 'sleeper' && key !== 'sleepPosition' && key !== 'sleepGoal' && key !== 'sharedSleepGoal'
      )
    );

    Object.keys(topLevelQuestions).forEach((key, i) => allQuestions.set(key, i));
    let currentQuestionTotal = allQuestions.size;
    currentForm.sleeper.forEach((item: any, key: any) =>
      Object.keys(item).forEach((i) => {
        if (i !== 'sleepPosition') {
          allQuestions.set(`${i}_${key}`, currentQuestionTotal);
          currentQuestionTotal += 1;
          if (i === 'name') {
            allQuestions.set(`bodyMeasurements_${key}`, currentQuestionTotal);
            currentQuestionTotal += 1;
          }
        }
      })
    );

    currentForm.sleeper.forEach((item: any, key: any) =>
      Object.keys(item).forEach((i) => {
        if (i === 'sleepPosition') {
          allQuestions.set(`${i}_${key}`, currentQuestionTotal);
          currentQuestionTotal += 1;
        }
      })
    );
    if (parseInt(currentForm.noSleepers) === 1) {
      allQuestions.set('sharedSleepGoal', allQuestions.size);
      if (allQuestions.has('sleepGoal')) {
        allQuestions.delete('sleepGoal');
      }
    } else {
      allQuestions.set('sleepGoal', allQuestions.size);
    }
  };

  setAllQuestions();

  const max: number = allQuestions.size;

  const ProgressBarValue = (currentQuestion: any) => {
    if (currentQuestion.startsWith('sleeper')) {
      const fieldName = `${currentQuestion.slice(10)}_${currentQuestion.slice(8, 9)}`;
      const subQuestionPosition = parseInt(allQuestions.get(fieldName)) + 1;

      return subQuestionPosition;
    }

    const questionPosition = parseInt(allQuestions.get(currentQuestion)) + 1;

    return questionPosition;
  };

  const updateBackPage = () => {
    if (backPage.override === true && backPage.backPageId) {
      setCurrentSleeper({ questionName: backPage.questionName, sleeper: backPage.newSleeperId });
      setPage(backPage.backPageId);
    }
  };

  useEffect(() => {
    setProgressBarValue(ProgressBarValue(currentSleeper.questionName));
  }, [currentSleeper]);

  if (isResultsPage) {
    return (
      <ResultsWrapper className={className}>
        <ResultsContainer>{children}</ResultsContainer>
      </ResultsWrapper>
    );
  }

  return (
    <Wrapper className={className}>
      <Container>
        {showNavigation && (
          <Navigation>
            <Button
              buttonType="link"
              icon="chevron-left"
              iconLeft
              onClick={backPage.override === true ? updateBackPage : previousStep}
            >
              back
            </Button>
            <ProgressBar max={max} value={progressBarValue} />
          </Navigation>
        )}

        {children}
        <Chair $orientation={layoutVariant} src={chair} alt="" aria-hidden width="468" height="406" loading="lazy" />
        <Plant $orientation={layoutVariant} src={plant} alt="" aria-hidden width="220" height="330" loading="lazy" />

        <div id="content-image-overlay" />
      </Container>
      <div id="image-overlay" />
      <div id="modal-root" />
    </Wrapper>
  );
};

export default Layout;
